import { UserActions, UserInfo } from './user.reducer'

export const setCurrentUserAction = (user: UserInfo) => ({
  type: UserActions.SET_CURRENT_USER,
  payload: user,
})
